<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nYsYIe/tc-custom/9781497641747.jpg?1726617369940" alt="This image is the cover for the book Sabotage, Jimmy Coates"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sabotage, Jimmy Coates
      </h1>
      <p class="bookDescription body article font2">
        <b>Betrayal is explosive</b><br/><br/> Shot down, stranded, and assumed dead, Jimmy faces his greatest struggle yet. The CIA spy plane that was supposed to carry him to safety is in flames, along with vital intelligence about secret missiles. The truth survives only in Jimmy’s head. He must get back to warn the CIA—if he can survive long enough.<br/><br/> Unsure of whom to trust, Jimmy is worried that his human side is slipping away. Should he let the programing take over? Will it save him or destroy him?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joe  Craig
      </h2>
      
      <p class="authorDescription body article">Joe Craig is an award-winning novelist, songwriter, screenwriter, and performer. Since studying philosophy at the University of Cambridge, he has also been a comic, a public-speaking and conversation coach, and a semipro cricketer. Since the first book in his bestselling Jimmy Coates series was published in 2005, the series has won over young fans across the world and converted thousands of previously reluctant readers with an electric mix of action, suspense, and thrilling twists.&#160;The<I> Times</I>&#160;of London calls Craig &ldquo;one of the best spy kids authors . . . outstanding at both writing and plotting.&rdquo; Craig&rsquo;s work has earned him a place alongside Anthony Horowitz, Charlie Higson, and Robert Muchamore.&#160;<BR /><BR />Craig tours the world entertaining packed houses at festivals, bookshops, libraries, and schools with <I>The Joe Craig Show</I>. His tall tales, improvised stories, and surprising theories about writing have enthralled audiences every bit as much as his books. In spare moments he eats sushi, plays the piano, watches movies, reads, draws, plays snooker and cricket, invents snacks, cooks, does martial arts training, and sleeps.<BR /><BR />Craig lives in London with his wife, broadcaster and adventurer Mary-Ann Ochota; his dog, Harpo the labradonkey; and his dwarf crocodile, Professor Sven. He keeps in touch with his readers through his website, www.joecraig.co.uk, and he is @joecraiguk on Twitter, Facebook, and Instagram.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6dbc46a1